module.exports = __webpack_public_path__ + "static/media/cardio.90118287.svg";